import React, { useCallback, useMemo, ReactNode } from 'react';
import { useDropzone } from 'react-dropzone';
import { ACCEPTED_FILE_TYPES } from "../../config/AcceptedFileTypes";
import "../../Styles/Partials/FIleDrop.css";
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';
import { AttachmentDropIcons } from '../../assets/svg/AttachmentDropIcons';



interface FileDropProps {
  onFilesDrop: (event: React.ChangeEvent<HTMLInputElement> | { target: { files: File[] } }) => void;
  children: ReactNode;
}

const FileDrop: React.FC<FileDropProps> = ({
  onFilesDrop,
  children
}) => {
  const auth = useAuth();
  const toast  = useToast();
  const disabled = !auth.user;

  const defaultOnDrop = useCallback((acceptedFiles: File[]) => {
    if (disabled) {
      toast('Sign in to Upload Files', 'error');
      return;
    }
    
    const syntheticEvent = { target: { files: acceptedFiles } };
    onFilesDrop(syntheticEvent);
  }, [disabled, onFilesDrop, toast]);

  const dropzoneConfig = useMemo(() => ({
    onDrop: defaultOnDrop,
    accept: ACCEPTED_FILE_TYPES,
    multiple: true,
    noClick: true,
    noKeyboard: true,
    disabled,
  }), [defaultOnDrop, disabled]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone(dropzoneConfig);

  return (
    <div {...getRootProps()} style={{ position: 'relative', flex: 1, minWidth: 0 }}>
      <input {...getInputProps()} />
      {isDragActive && (
        <div className="file-drop-overlay">
          <div className="file-drop-content">
            <div className="file-drop-icon">
              <AttachmentDropIcons size={120} />
            </div>
            <h3>Drop your files here</h3>
            <p>Release to attach PDFs, images or documents to your chat</p>
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

export default FileDrop;
